<template>
  <div class="box2">
    <pageTitle title="放眼所见&nbsp;&nbsp;皆为前端" titleColor="#3E4F48" />
    <div class="title">
      <p>竞争对手少、方向选择多面、晋升路径明确</p>
      <span></span>
    </div>
    <div class="container" @scroll="handleScroll">
      <div class="scrollBox" ref="content">
        <div class="firstWrap">
          <div class="warpTitle">竞争对手少</div>
          <div class="smallTitleWrap">前端VS后端，无竞争对手，且不过时</div>
          <div class="content advantage">
            <h2 class="advantage-title advantage-title-border">
              <span>前端</span>
            </h2>
            <ul class="advantage-list">
              <li><i class="icon_check_fill"></i>前端技术生态都是建立在JavaScript基础上</li>
              <li><i class="icon_check_fill"></i>JavaScript是前端工程师使用的唯一编程语言</li>
              <li><i class="icon_check_fill"></i>没有竞争对手且不会过时</li>
            </ul>
            <div class="advantage-second">
              <h3 class="advantage-title advantage-title-second">竞争激烈的后端语言</h3>
              <ul class="advantage-list-second">
                <li>GO</li>
                <li>C++</li>
                <li>PHP</li>
                <li>C#</li>
                <li>Java</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="secondWrap">
          <div class="warpTitle">就业选择多</div>
          <div class="smallTitleWrap">放眼所见，皆为前端，10+ 行业可选择</div>
          <div class="content">
            <div class="contentTitle" :class="cur == 1 ? 'otherStyle' : ' '">
              {{
                cur == 0
                  ? "前端工程师覆盖行业面广泛"
                  : "H5端、Web端、小程序...就业岗位多重选择"
              }}
            </div>
            <swiper
              :options="swiperOption"
              ref="mySwiper"
              class="swiperitems"
              @slideChange="slideChange()"
            >
              <swiper-slide>
                <img src="../../../assets/coursePage/web/box2/2.png" alt="" />
              </swiper-slide>
              <swiper-slide>
                <img src="../../../assets/coursePage/web/box2/3.png" alt="" />
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination-box2"></div>
          </div>
        </div>
        <div class="thirdWrap">
          <div class="warpTitle">晋升速度快</div>
          <div class="smallTitleWrap">新手接纳度高，平均4年+ 可晋升主管</div>
          <div class="content">
            <div class="contentTitle">前端工程师晋升通道</div>
            <img src="../../../assets/coursePage/web/box2/4.png" alt="" />
            <div class="desc">* 具体晋升通道以个人努力程度为准</div>
          </div>
        </div>
        <div class="seat"></div>
      </div>
      <div class="scorll-box">
        <div class="scorll-block" :style="styleVar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      cur: 0,
      scroll: 0,
      swiperOption: {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 40,
        autoplay: true,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    slideChange() {
      this.cur = this.$refs.mySwiper.$el.swiper.realIndex;
    },
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/web/box2/bgc.png") no-repeat;
  background-size: cover;
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .title {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0c9e7b;
    line-height: 52px;
    display: table;
    position: relative;
    margin: 48px auto;
    text-align: center;
    p {
      position: relative;
      z-index: 10;
    }
    span {
      width: 100%;
      height: 20px;
      background: #d4f7ef;
      position: absolute;
      display: block;
      top: 32px;
      left: 0;
      z-index: 1;
    }
  }
  .container {
    overflow-x: auto;
    height: 698px;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }
  }
  .scrollBox {
    display: flex;

    .firstWrap,
    .secondWrap,
    .thirdWrap {
      width: 660px;
      height: 668px;
      background: #ffffff;
      box-shadow: 0px 8px 24px 0px rgba(12, 158, 123, 0.12);
      border-radius: 20px;
      padding: 48px 16px 16px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-content: flex-start;
      margin: 0 auto;
      margin-left: 32px;
      .warpTitle {
        width: 420px;
        height: 44px;
        background: #ffffff;
        border-radius: 20px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
        text-align: center;
      }
      .smallTitleWrap {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 44px;
        margin: 8px 0 32px;
      }
      .content {
        width: 628px;
        height: 472px;
        background: linear-gradient(360deg, #ecfffa 0%, #e5fdf7 100%);
        border-radius: 12px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-content: flex-start;
        .contentTitle {
          width: 420px;
          height: 44px;
          background: #ffffff;
          border-radius: 20px;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
          text-align: center;
          margin: 32px 0 8px;
        }
        .otherStyle {
          width: 468px;
        }
        img {
          width: 604px;
          height: 288px;
          object-fit: contain;
        }
        .desc {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0c9e7b;
          line-height: 28px;
          margin-top: 12px;
          padding: 0 24px;
        }
      }

      .advantage{
        flex-direction: column;
        align-items: center;
        color: #1C212A;
        justify-content: start;
        padding: 40px 0 40px 0;
        box-sizing: border-box;
        
        .advantage-title {
          font-size: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;

          span{
            position: relative;
            z-index: 2;
          }

          &.advantage-title-border::after{
            content: '';
            display: block;
            width: 80px;
            height: 12px;
            background-color: #CEEBE3;
            margin-top: -14px;
            position: relative;
            z-index: 1;
          }
        }

        .advantage-list {
          font-size: 26px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 30px;

          li {
            display: flex;
            align-items: center;

            .icon_check_fill {
              background: url("../../../assets/coursePage/web/box2/icon_check_fill.png") no-repeat left center;
              width: 28px;
              height: 28px;
              margin-right: 12px;
              background-size: cover;
            }
          }
        }

        .advantage-second {
          margin-top: 30px;
          height: 150px;
          width: calc(100% - 60px);
          border-radius: 28px;
          background-image: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 10px;
          box-sizing: border-box;
        }

        .advantage-list-second {
          display: flex;
          font-size: 28px;
          gap: 16px;
          margin-top: 20px;

          li {
            flex: 1;
            height: 50px;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 28px;
          }
        }


      }
    }
    .secondWrap,
    .thirdWrap {
      img {
        height: 328px !important;
      }
      .swiper-slide {
        display: flex;
        justify-content: center;
      }
      .swiper-pagination-box2 {
        display: flex;
        align-items: center;
        margin-top: 20px;
      }

      /deep/ .swiper-pagination-bullet {
        width: 12px;
        height: 6px;
        background: #c0ebe1;
        border-radius: 3px;
        opacity: 1;
      }

      /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 24px;
        height: 6px;
        background: #2ebe9c;
        border-radius: 3px;
        margin: 0 8px;
      }
    }
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    width: 70px;
    height: 6px;
    background: #c0ebe1;
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 24px;
      height: 6px;
      background: #2ebe9c;
      border-radius: 3px;
    }
  }
}
</style>
